import React from "react";

const NexArrowIcon = ({name, color, size}) => (
    <svg viewBox="0 0 19 32" className={`icon icon-${name}`} fill={color} width={size} height={size}  xmlns="http://www.w3.org/2000/svg">
        <path d="M.443 3.212L3.155.5 18.526 16l-2.713 2.712L.442 3.212z"></path>
      	<path d="M.443 28.788l15.371-15.5L18.527 16 3.156 31.5.444 28.788z"></path>
    </svg>
);

export default NexArrowIcon;